<template>
    <span class="text-success mr-2" v-if="pagamentoNotaFiscal.documentoId">
        <i
            class="fa fa-external-link fa-lg icon-button"
            title="Abrir Nota Fiscal em Nova Aba"
            @click.stop="visualizarNotaFiscal()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamentoNotaFiscal: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    methods: {
        visualizarNotaFiscal() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .downloadNotaFiscal(this.pagamentoNotaFiscal.pagamentoId, this.pagamentoNotaFiscal.pagamentoNotaFiscalId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao visualizar a nota fiscal!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            // Abre o arquivo em uma nova aba para visualização
                            const blob = new Blob([response], {
                                type: response.type || 'application/pdf'
                            })
                            const url = URL.createObjectURL(blob)
                            const newWindow = window.open(url, '_blank')
                            
                            if (!newWindow) {
                                // Se o popup foi bloqueado, faz o download direto
                                this.downloadFile(blob, this.getFileName())
                                this.$toast.warning(
                                    'Pop-up bloqueado! Arquivo baixado automaticamente.',
                                    'AVISO',
                                    this.$toastConfig.warning
                                )
                            } else {
                                // Pergunta se o usuário quer baixar após visualizar
                                setTimeout(() => {
                                    const shouldDownload = confirm('Deseja baixar o arquivo?')
                                    if (shouldDownload) {
                                        this.downloadFile(blob, this.getFileName())
                                    }
                                    URL.revokeObjectURL(url)
                                }, 2000)
                            }
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
                .catch(error => {
                    this.$store.dispatch('removeRequest')
                    this.$toast.error(
                        'Erro ao visualizar a nota fiscal!',
                        'ERROR',
                        this.$toastConfig.error
                    )
                    console.error('Erro ao visualizar nota fiscal:', error)
                })
        },

        downloadFile(blob, filename) {
            const link = document.createElement('a')
            const url = URL.createObjectURL(blob)
            link.href = url
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        },

        getFileName() {
            const notaFiscal = this.pagamentoNotaFiscal
            const numero = notaFiscal.numeroNota || 'sem-numero'
            const tipo = notaFiscal.tipo || 'NF'
            return `${tipo}-${numero}.pdf`
        }
    }
}
</script>
